import React from 'react';
import { CheckCircle2 } from 'lucide-react';
const results = [{
  title: 'Lifting de Pestañas',
  description: 'Resultados naturales y duraderos logrados por alumnas del módulo 2.',
  image: 'https://cdn.magicpatterns.com/uploads/x3eXn8dQ8c2owpfBRD4QDZ/BLOG-4-1.png'
}, {
  title: 'Perfilado de Cejas',
  description: 'Diseño y perfilado perfecto siguiendo la morfología del rostro.',
  image: 'https://images.unsplash.com/photo-1596704017254-9b121068fb31?q=80&w=800&auto=format&fit=crop'
}, {
  title: 'Tratamientos Faciales',
  description: 'Piel radiante y saludable con técnicas de limpieza profunda.',
  image: 'https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?q=80&w=800&auto=format&fit=crop'
}, {
  title: 'Manicuría Profesional',
  description: 'Acabados impecables y diseños modernos aprendidos desde cero.',
  image: 'https://images.unsplash.com/photo-1632345031435-8727f6897d53?q=80&w=800&auto=format&fit=crop'
}];
export function ResultsSection() {
  return <section className="py-20 bg-white" data-id="element-213">
      <div className="max-w-6xl mx-auto px-4" data-id="element-214">
        <div className="text-center mb-16" data-id="element-215">
          <div className="inline-block bg-pink-100 text-pink-700 px-4 py-1 rounded-full text-sm font-bold uppercase tracking-wider mb-4" data-id="element-216">
            Resultados Reales
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6" data-id="element-217">
            Lo que lograrás con nuestras técnicas
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-218">
            Estas son fotos reales de trabajos realizados por nuestras alumnas
            aplicando el paso a paso del MegaPack.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 lg:gap-12" data-id="element-219">
          {results.map((item, idx) => <div key={idx} className="group relative bg-gray-50 rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100" data-id="element-220">
              <div className="aspect-[4/3] overflow-hidden relative" data-id="element-221">
                <div className="absolute inset-0 bg-black/10 group-hover:bg-black/0 transition-colors duration-300 z-10" data-id="element-222" />
                <img src={item.image} alt={item.title} className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-500" data-id="element-223" />
                <div className="absolute bottom-4 left-4 right-4 z-20" data-id="element-224">
                  <div className="bg-white/95 backdrop-blur-sm p-4 rounded-xl shadow-sm" data-id="element-225">
                    <h3 className="font-bold text-lg text-gray-900 mb-1 flex items-center" data-id="element-226">
                      <CheckCircle2 className="w-5 h-5 text-green-500 mr-2" data-id="element-227" />
                      {item.title}
                    </h3>
                    <p className="text-sm text-gray-600" data-id="element-228">{item.description}</p>
                  </div>
                </div>
              </div>
            </div>)}
        </div>

        <div className="mt-12 text-center" data-id="element-229">
          <p className="text-gray-500 italic" data-id="element-230">
            * Resultados pueden variar según la dedicación y práctica de cada
            alumna.
          </p>
        </div>
      </div>
    </section>;
}